import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    return value;
  } else {
    return "";
  }
}

const CryptogramPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
        <Row>
            <Col><strong>{data.label}</strong></Col>
            <Col>
                <div>
                    Approved
                </div>
                <div>
                    {getValue(data.value)}
                </div>
            </Col>
        </Row>
  ),
  id: 'cryptogramPropertyPlugin',
  title: 'Cryptogram Property',
  description: 'Cryptogram Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Cryptogram',
        },
      },
      required: ['label'],
    },
  },
};

export default CryptogramPropertyPlugin;